// Release Notes API endpoints (RTK Query)
import baseApi, { apiTags } from '../api/baseApi'

const releaseNotesApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    fetchReleaseNotes: builder.query({
      providesTags: [apiTags.RELEASE_NOTE],
      query: () => 'release-notes',
    }),

    fetchReleaseNoteById: builder.query({
      query: id => `release-notes/${id}`,
    }),

    createReleaseNote: builder.mutation({
      invalidatesTags: [apiTags.RELEASE_NOTE],
      query: payload => ({
        body: payload,
        method: 'POST',
        url: 'release-notes',
      }),
    }),

    updateReleaseNote: builder.mutation({
      invalidatesTags: [apiTags.RELEASE_NOTE],
      query: ({ id, ...body }) => ({
        body,
        method: 'PUT',
        url: `release-notes/${id}`,
      }),
    }),

    publishReleaseNote: builder.mutation({
      invalidatesTags: [apiTags.RELEASE_NOTE],
      query: id => ({
        method: 'PATCH',
        url: `release-notes/${id}/publish`,
      }),
    }),
  }),
  overrideExisting: true,
})

export const {
  useFetchReleaseNotesQuery,
  useLazyFetchReleaseNoteByIdQuery,
  useCreateReleaseNoteMutation,
  useUpdateReleaseNoteMutation,
  usePublishReleaseNoteMutation,
} = releaseNotesApi

export default releaseNotesApi
